import { render, staticRenderFns } from "./TabbedCollectionsLayout.vue?vue&type=template&id=074f46a7&scoped=true"
import script from "./TabbedCollectionsLayout.vue?vue&type=script&lang=js"
export * from "./TabbedCollectionsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f46a7",
  null
  
)

export default component.exports